import PropTypes from 'prop-types';
import React from 'react';

class MarketWeightsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { total: 0 };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let totalValue = 0;
    this.props.market_weights.forEach((m) => {
      const mValue = parseFloat(m.weight);
      totalValue += mValue;
    })
    this.setState({ total: totalValue });
  }

  handleChange() {
    let inputs = document.querySelectorAll('.weight-percent');
    let totalValue = 0;
    inputs.forEach((input) => {
      const userValue = parseFloat(input.value) || 0;
      totalValue += userValue;
    });

    this.setState({ total: totalValue });
  }

  render() {
    return (
      <div
        id="MarketWeightsForm"
        className="shadow overflow-hidden px-4 py-5 bg-white sm:p-6 sm:rounded-md"
      >
        <div className="grid grid-cols-2">
          <div className="col-span-1 font-medium text-gray-700">Client</div>
          <div className="col-span-1 col-start-2 font-medium text-gray-700">
            Proportional Market Weight
          </div>
        </div>
        {this.props.clients.map((client, index) => (
          <div className="grid grid-cols-2 py-3" id={`${client.name}-weight`} key={client.name}>
            <div className="col-span-1">
              <label className="block  text-gray-700">{client.name}</label>
              <input
                type="hidden"
                id="market_weights_market_weights__client_id"
                name="market_weights[market_weights][][client_id]"
                value={client.id}
              />
            </div>
            <div className="col-start-2">
              <input
                type="number"
                min="0.01"
                readOnly={false}
                defaultValue={
                  this.props.market_weights.length > 0 && this.props.market_weights[index]
                    ? this.props.market_weights[index].weight
                    : null
                }
                step="0.01"
                onChange={this.handleChange}
                id={`${client.name}__weight`}
                name="market_weights[market_weights][][weight]"
                className="weight-percent w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
              ></input>
            </div>

            <input
              type="hidden"
              id="market_weights_market_weights__region_id"
              name="market_weights[market_weights][][region_id]"
              value={this.props.region}
            />
          </div>
        ))}
        <div className="col-span-1 col-start-2 grid grid-cols-2">
          <div className="col-span-1  font-medium text-gray-700">Total</div>
          <div id="totalCounter" className="col-span-1  font-medium text-gray-700" >
            {this.state.total}
          </div>
        </div>
        <div className="actions">
          <input type="submit" value="Submit" />
          <a className="secondary-btn ml-2" href="/regions">Return to Regions</a>
        </div>
      </div>
    );
  }
}

MarketWeightsForm.propTypes = {
  region: PropTypes.number,
  clients: PropTypes.array,
  market_weights: PropTypes.array,
};

export default MarketWeightsForm;
